import React from 'react'

const Mask = () => {
  return (
    <svg
      fill='none'
      height='22'
      viewBox='0 0 30 30'
      width='22'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.173 1.955a.572.572 0 00-.627.072C21.477 7.134 21.156-.526 15 2.115 8.845-.526 8.523 7.134 2.454 2.027a.578.578 0 00-.873.156.62.62 0 00-.085.329c.047 3.401.9 12.19 8.448 12.19 1.657.015 3.302-.312 4.835-.961a.541.541 0 01.442 0c1.533.65 3.177.976 4.835.96 7.547 0 8.4-8.788 8.448-12.19a.62.62 0 00-.087-.328.594.594 0 00-.244-.228z'
        stroke='var(--tips__icon__stroke__color)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M28.504 2.508v26.887M9.52 5.84c-1.933-.357-3.676.363-3.892 1.611-.216 1.249 1.175 2.543 3.11 2.906 1.935.364 3.676-.363 3.892-1.611.216-1.249-1.176-2.55-3.11-2.907zM20.48 5.84c1.933-.357 3.676.363 3.892 1.611.216 1.249-1.175 2.543-3.11 2.906-1.935.364-3.676-.363-3.892-1.611-.216-1.249 1.176-2.55 3.11-2.907z'
        stroke='var(--tips__icon__stroke__color)'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Mask
